"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _ManipulableContainer = _interopRequireDefault(require("../ManipulableContainer"));
var _InlineToolboxButton = _interopRequireDefault(require("./InlineToolboxButton"));
var _styles = _interopRequireDefault(require("./styles"));
var _CanvasProvider = require("../../CanvasInterface/CanvasProvider");
var _Canvas = require("../../CanvasInterface/Canvas");
var _EditorContainer = require("../Editor/EditorContainer");
var _Logger = _interopRequireDefault(require("../../Utils/Logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _Logger["default"]('InlineToolbox');
var InlineToolBox = /*#__PURE__*/function (_React$Component) {
  _inherits(InlineToolBox, _React$Component);
  var _super = _createSuper(InlineToolBox);
  function InlineToolBox() {
    var _this;
    _classCallCheck(this, InlineToolBox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      show: false
    });
    _defineProperty(_assertThisInitialized(_this), "getClientPositionFromEvent", function (evt) {
      var isTouchEvent = !!evt.changedTouches;
      return {
        isTouchEvent: isTouchEvent,
        x: isTouchEvent ? evt.changedTouches[0].clientX : evt.clientX,
        y: isTouchEvent ? evt.changedTouches[0].clientY : evt.clientY
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onScalingChange", function (evt) {
      var selectedObject = _this.props.canvas.selectedObject;
      if (!selectedObject) {
        return;
      }
      selectedObject.activeAction = 'scale';
      var clientPosition = _this.getClientPositionFromEvent(evt);
      var iDistance = selectedObject.getDistanceToCenter(clientPosition.x, clientPosition.y);
      var _selectedObject$getTr = selectedObject.getTransformedRect(),
        bottomRight = _selectedObject$getTr.bottomRight;
      var cDiff = {
        x: clientPosition.x - bottomRight.x,
        y: clientPosition.y - bottomRight.y
      };
      iDistance = selectedObject.getDistanceToCenter(bottomRight.x, bottomRight.y);
      var mouseMove = function mouseMove(evt) {
        var clientPosition = _this.getClientPositionFromEvent(evt);
        evt.preventDefault();
        var dPos = {
          x: clientPosition.x - cDiff.x,
          y: clientPosition.y - cDiff.y
        };
        var dDistance = selectedObject.getDistanceToCenter(dPos.x, dPos.y);
        var ratio = dDistance / iDistance;
        selectedObject.scaling *= ratio;
        iDistance = dDistance;
        _this.updateToolbarTransform();
      };
      var mouseUp = function mouseUp(evt) {
        selectedObject.activeAction = '';
        var clientPosition = _this.getClientPositionFromEvent(evt);
        evt.preventDefault();
        document.removeEventListener(clientPosition.isTouchEvent ? 'touchmove' : 'mousemove', mouseMove, {
          passive: false
        });
        document.removeEventListener(clientPosition.isTouchEvent ? 'touchend' : 'mouseup', mouseUp);
      };
      document.addEventListener(clientPosition.isTouchEvent ? 'touchmove' : 'mousemove', mouseMove, {
        passive: false
      });
      document.addEventListener(clientPosition.isTouchEvent ? 'touchend' : 'mouseup', mouseUp);
    });
    _defineProperty(_assertThisInitialized(_this), "onRotationChange", function (evt) {
      var _this$props$canvas = _this.props.canvas,
        selectedObject = _this$props$canvas.selectedObject,
        canvasElement = _this$props$canvas.canvasElement;
      if (!selectedObject) {
        return;
      }
      selectedObject.activeAction = 'rotate';
      var clientPosition = _this.getClientPositionFromEvent(evt);

      // const { canvasPosition } = this.props;
      var canvasPosition = canvasElement.getBoundingClientRect();
      var center = selectedObject.getCenter(); // selectedObject.getTransformedRect();

      // add the offset to the center
      center.x += canvasPosition.left;
      center.y += canvasPosition.top;
      var iAngle = Math.atan2(clientPosition.y - center.y, clientPosition.x - center.x);
      var mouseMove = function mouseMove(evt) {
        var clientPosition = _this.getClientPositionFromEvent(evt);
        evt.preventDefault();
        var dAngle = Math.atan2(clientPosition.y - center.y, clientPosition.x - center.x);
        var delta = (dAngle - iAngle) / Math.PI * 180;
        selectedObject.rotation += delta;
        iAngle = dAngle;
        _this.updateToolbarTransform();
      };
      var mouseUp = function mouseUp(evt) {
        selectedObject.activeAction = '';
        var clientPosition = _this.getClientPositionFromEvent(evt);
        evt.preventDefault();
        selectedObject.rotation = _this.snapToDeg(selectedObject.rotation);
        _this.updateToolbarTransform();
        document.removeEventListener(clientPosition.isTouchEvent ? 'touchmove' : 'mousemove', mouseMove, {
          passive: false
        });
        document.removeEventListener(clientPosition.isTouchEvent ? 'touchend' : 'mouseup', mouseUp);
      };
      document.addEventListener(clientPosition.isTouchEvent ? 'touchmove' : 'mousemove', mouseMove, {
        passive: false
      });
      document.addEventListener(clientPosition.isTouchEvent ? 'touchend' : 'mouseup', mouseUp);
    });
    _defineProperty(_assertThisInitialized(_this), "onDeleteClick", function () {
      var selectedObject = _this.props.canvas.selectedObject;
      if (selectedObject) {
        selectedObject.remove();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "snapToDeg", function (valueDeg) {
      var toleranceDeg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
      var snapValues = [0, 45, 90, 135, 180, 225, 270, 315, 360];
      var foundSnapValue = snapValues.find(function (value) {
        return Math.abs(valueDeg - value) <= toleranceDeg;
      });
      if (foundSnapValue === undefined) {
        return valueDeg;
      }
      return foundSnapValue === 360 ? 0 : foundSnapValue;
    });
    _defineProperty(_assertThisInitialized(_this), "bottomRightContainerRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "topRightContainerRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "bottomLeftContainerRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "topLeftContainerRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "angleLabelRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "renderToolboxButton", function (positionName) {
      var _this$props = _this.props,
        renderToolboxButton = _this$props.renderToolboxButton,
        canvas = _this$props.canvas,
        selectedObject = _this$props.selectedObject;
      var _assertThisInitialize = _assertThisInitialized(_this),
        onScalingChange = _assertThisInitialize.onScalingChange,
        onRotationChange = _assertThisInitialize.onRotationChange,
        onDeleteClick = _assertThisInitialize.onDeleteClick;
      if (renderToolboxButton) {
        // call the render prop method with the position name and the available functions
        return renderToolboxButton({
          canvas: canvas,
          selectedObject: selectedObject,
          positionName: positionName,
          onScalingChange: onScalingChange,
          onRotationChange: onRotationChange,
          onDeleteClick: onDeleteClick,
          components: {
            InlineToolboxButton: _InlineToolboxButton["default"]
          }
        });
      }
      if (!selectedObject) {
        return null;
      }
      switch (positionName) {
        case 'topRight':
          return !selectedObject.locked && /*#__PURE__*/_react["default"].createElement(_InlineToolboxButton["default"], {
            style: {
              background: 'red'
            },
            onTouchStart: onRotationChange,
            onMouseDown: onRotationChange
          });
        case 'bottomRight':
          return !selectedObject.locked && !selectedObject.autoFit && /*#__PURE__*/_react["default"].createElement(_InlineToolboxButton["default"], {
            style: {
              background: 'green'
            },
            onTouchStart: onScalingChange,
            onMouseDown: onScalingChange
          });
        case 'bottomLeft':
          return /*#__PURE__*/_react["default"].createElement(_InlineToolboxButton["default"], {
            style: {
              background: 'blue'
            },
            onClick: onDeleteClick
          });
        case 'topLeft':
        default:
          return null;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "AngleLabel", function (_ref) {
      var className = _ref.className,
        renderAngleLabel = _ref.renderAngleLabel;
      var selectedObjectInCanvas = (0, _get["default"])(_this.props, 'canvas.selectedObject', null);
      var selectedObject = selectedObjectInCanvas || (0, _get["default"])(_this.props, 'selectedObject', null);
      var rotation = (0, _get["default"])(selectedObject, 'rotation', 0);
      var degAngle = "".concat(Math.round(rotation * 100) / 100, " \xB0");
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, renderAngleLabel ? renderAngleLabel(degAngle) : /*#__PURE__*/_react["default"].createElement("span", null, degAngle));
    });
    return _this;
  }
  _createClass(InlineToolBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initState();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.initState(prevProps);
      if (!prevState.show && this.state.show && this.props.selectedObject || this.props.selectedObject && this.props.selectedObject !== prevProps.selectedObject || this.props.selectedObject && this.props.canvasPosition !== prevProps.canvasPosition) {
        this.updateToolbarTransform();
      }
    }
  }, {
    key: "initState",
    value: function initState() {
      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var selectedObject = this.props.selectedObject;
      if (selectedObject && selectedObject !== prevProps.selectedObject) {
        this.setState({
          show: !selectedObject.grabbed
        });
      } else if (!selectedObject && this.state.show) {
        this.setState({
          show: false
        });
      }
    }
  }, {
    key: "updateToolbarTransform",
    value: function updateToolbarTransform() {
      var selectedObject = this.props.canvas.selectedObject;
      if (!selectedObject) {
        return;
      }
      var _selectedObject$getTr2 = selectedObject.getTransformedRect(),
        topRight = _selectedObject$getTr2.topRight,
        bottomRight = _selectedObject$getTr2.bottomRight,
        bottomLeft = _selectedObject$getTr2.bottomLeft,
        topLeft = _selectedObject$getTr2.topLeft;
      this.bottomRightContainerRef.current && this.bottomRightContainerRef.current.updateTransform({
        translate: {
          x: bottomRight.x,
          y: bottomRight.y
        },
        rotate: selectedObject.rotation
      });
      this.topRightContainerRef.current && this.topRightContainerRef.current.updateTransform({
        translate: {
          x: topRight.x,
          y: topRight.y
        },
        rotate: selectedObject.rotation
      });
      this.bottomLeftContainerRef.current && this.bottomLeftContainerRef.current.updateTransform({
        translate: {
          x: bottomLeft.x,
          y: bottomLeft.y
        },
        rotate: selectedObject.rotation
      });
      this.topLeftContainerRef.current && this.topLeftContainerRef.current.updateTransform({
        translate: {
          x: topLeft.x,
          y: topLeft.y
        },
        rotate: selectedObject.rotation
      });
      var anglePosition = topRight;
      var radAngle = selectedObject.rotation * Math.PI / 180;
      if (selectedObject.rotation >= 270) {
        anglePosition.x += 50 * Math.cos(radAngle);
        anglePosition.y += 70 * Math.sin(radAngle);
      } else if (selectedObject.rotation >= 180) {
        anglePosition.x += 140 * Math.cos(radAngle);
        anglePosition.y += 70 * Math.sin(radAngle);
      } else if (selectedObject.rotation >= 90) {
        anglePosition.x += 140 * Math.cos(radAngle);
        anglePosition.y += 50 * Math.sin(radAngle);
      } else {
        anglePosition.x += 50 * Math.cos(radAngle);
        anglePosition.y += 50 * Math.sin(radAngle);
      }
      this.angleLabelRef.current && this.angleLabelRef.current.updateTransform({
        translate: {
          x: anglePosition.x,
          y: anglePosition.y
        },
        rotate: 0
      });
    }
  }, {
    key: "render",
    value: function render() {
      logger.log('render InlineToolbox');
      if (this.state.show) {
        var _this$props2 = this.props,
          classes = _this$props2.classes,
          children = _this$props2.children,
          canvas = _this$props2.canvas,
          selectedObject = _this$props2.selectedObject,
          renderAngleLabel = _this$props2.renderAngleLabel,
          ContainerComponent = _this$props2.ContainerComponent,
          canvasPosition = _this$props2.canvasPosition;
        var AngleLabel = this.AngleLabel;
        var renderToolboxButton = this.renderToolboxButton,
          topRightContainerRef = this.topRightContainerRef,
          bottomRightContainerRef = this.bottomRightContainerRef,
          bottomLeftContainerRef = this.bottomLeftContainerRef,
          topLeftContainerRef = this.topLeftContainerRef,
          angleLabelRef = this.angleLabelRef;
        if (typeof children === 'function') {
          // call the render prop with all the necessary input
          return children({
            refs: {
              topRightContainerRef: topRightContainerRef,
              bottomRightContainerRef: bottomRightContainerRef,
              bottomLeftContainerRef: bottomLeftContainerRef,
              topLeftContainerRef: topLeftContainerRef,
              angleLabelRef: angleLabelRef
            },
            classes: classes,
            canvas: canvas,
            selectedObject: selectedObject,
            renderToolboxButton: renderToolboxButton,
            components: {
              ManipulableContainer: _ManipulableContainer["default"],
              InlineToolboxButton: _InlineToolboxButton["default"]
            }
          });
        }
        return /*#__PURE__*/_react["default"].createElement(ContainerComponent, {
          canvasPosition: canvasPosition,
          canvas: canvas,
          inlineToolboxRef: this
        }, /*#__PURE__*/_react["default"].createElement(_ManipulableContainer["default"], {
          ref: angleLabelRef,
          className: classes.angleLabelContainer
        }, /*#__PURE__*/_react["default"].createElement(AngleLabel, {
          className: classes.angleText,
          renderAngleLabel: renderAngleLabel
        })), /*#__PURE__*/_react["default"].createElement(_ManipulableContainer["default"], {
          ref: topRightContainerRef,
          className: classes.buttonContainer
        }, renderToolboxButton('topRight')), /*#__PURE__*/_react["default"].createElement(_ManipulableContainer["default"], {
          ref: bottomRightContainerRef,
          className: classes.buttonContainer
        }, renderToolboxButton('bottomRight')), /*#__PURE__*/_react["default"].createElement(_ManipulableContainer["default"], {
          ref: bottomLeftContainerRef,
          className: classes.buttonContainer
        }, renderToolboxButton('bottomLeft')), /*#__PURE__*/_react["default"].createElement(_ManipulableContainer["default"], {
          ref: topLeftContainerRef,
          className: classes.buttonContainer
        }, renderToolboxButton('topLeft')));
      }
      return null;
    }
  }]);
  return InlineToolBox;
}(_react["default"].Component);
_defineProperty(InlineToolBox, "propTypes", {
  children: _propTypes["default"].func,
  selectedObject: _propTypes["default"].object,
  renderToolboxButton: _propTypes["default"].func,
  canvasPosition: _propTypes["default"].shape({
    left: _propTypes["default"].number.isRequired,
    top: _propTypes["default"].number.isRequired
  }).isRequired,
  canvas: _propTypes["default"].instanceOf(_Canvas.AbstractCanvas).isRequired,
  classes: _propTypes["default"].object.isRequired,
  renderAngleLabel: _propTypes["default"].func,
  ContainerComponent: _propTypes["default"].elementType
});
_defineProperty(InlineToolBox, "defaultProps", {
  ContainerComponent: function ContainerComponent(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  }
});
var _default = exports["default"] = (0, _withStyles["default"])(_styles["default"], {
  name: 'Designer-InlineToolbox'
})((0, _CanvasProvider.withCanvas)((0, _EditorContainer.withCanvasPosition)((0, _CanvasProvider.withCanvasState)(InlineToolBox))));